import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
  providedIn: 'root'
})
export class LimSimDataService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) {
  }

  public getList(start, count, sortBy, sortDirection, gridFilters) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/LimSim/GetList?start=${start}&length=${count}&sortBy=${sortBy}&sortDirection=${sortDirection}&gridFilters=${JSON.stringify(gridFilters)}`;
    return this.httpClient.get(url);
  }

  public get(id) {
    var url: string;
    url = `${this.configService.getConfig().apiURL}v1/Internal/LimSim/Get?id=${id}`;
    return this.httpClient.get(url);
  }

  public getResults(id) {
    var url: string;
    url = `${this.configService.getConfig().apiURL}v1/Internal/LimSim/GetResults?id=${id}`;
    return this.httpClient.get(url);
  } 

  public saveResults(testResult) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/LimSim/SaveResults`;
    return this.httpClient.put(url, testResult);
  }

}
